<template>
	<div class="card card-custom card-stretch gutter-b">
		<div class="card-header border-0" v-if="name">
			<h3 class="card-title font-weight-bolder text-dark">{{ name }} - iDirect Heat Map</h3>
		</div>
		<div class="card-body px-5 pt-0">
			<div class="row">
				<div class="col-md-6 fade-element-in">
					<p class="text-center">Downstream</p>
					<heatmap :data="data" :id="DID" dir="rx" />
				</div>
				<div class="col-md-6 fade-element-in">
					<p class="text-center">Upstream</p>
					<heatmap :data="data" :id="DID" dir="tx" />
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 text-center">Last 60 days : Total traffic within each hour</div>
			</div>
		</div>
	</div>
</template>

<script>
import swMixin from '@/core/services/mixins/serviceworker.mixin';

export default {
	name: 'IdirectHeatMap',
	mixins: [swMixin],
	components: { heatmap: () => import('@/view/content/lib/heatmap.vue') },
	props: ['name', 'DID'],
	data() {
		return { data: null };
	},
	methods: {
		processData(data) {
			this.data = data;
		},
	},
	mounted() {
		this.$http.get(`idirect/heatmap/${this.DID}`).then((resp) => {
			this.processData(resp.data.data);
			this.csv = resp.data.csv;
			this.loaded = true;
		});
		this.setSWListener('idirect/heatmap', (data) => {
			this.processData(data.data);
			this.csv = data.csv;
		});
	},
};
</script>

<style>
</style>